<!-- <link rel="stylesheet" [href]='safeUrl'> -->
<!--<app-header (lang)="onLangChange($event)"></app-header>-->
<router-outlet></router-outlet>
<app-footer></app-footer>

